<div *ngIf="documentDetails">
    <div class="card">
        <div class="card-body">
            <div mat-dialog-title class="heading">
                Update Category
                <!-- <mat-divider></mat-divider> -->
            </div>

            <div class="container">
                <div class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Category: </span>
                    <span class="properties-value col-8">{{documentDetails.categoryName}}</span>
                </div>
                <div class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Title: </span>
                    <span class="properties-value col-8">{{documentDetails.documentName}}</span>
                </div>
                <div class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Document Id: </span>
                    <span class="properties-value col-8">{{documentDetails.documentId}}</span>
                </div>
                <div *ngIf=documentDetails.locked class="properties-column row">
                    <span class="col-4" style="font-weight: 500;">Locked By: </span>
                    <span class="properties-value col-8">{{documentDetails.locked_by}}</span>
                </div>
            </div>
        </div>
    </div>

    <mat-accordion displayMode="flat">
        <mat-expansion-panel open>
            <mat-expansion-panel-header [class.selected-header]="selectedHeader === 2" (click)="selectedHeader = 2"
                collapsedHeight="38px" expandedHeight="38px">
                <mat-panel-title>File Metadata</mat-panel-title>
                <mat-divider></mat-divider>
            </mat-expansion-panel-header>
            <div>
                <div *ngIf="propertyCols.length < 1">No metadata defined for this document</div>
                <mat-list-item *ngFor="let column of propertyCols">
                    <div class="properties-column" matLine> <span style="font-weight: 500">{{column}}</span>
                        <span class="properties-value">{{documentProp[column]}}</span>
                    </div>
                </mat-list-item>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div *ngIf="!uploadMessage">
        <div class="input-group-sm mb-3 mt-2 input-group col-12">
            <div class="input-group-prepend">
                <span class="input-group-text form-label-105">Category</span>
            </div>
            <mat-select name="category_names" class="form-control" [(ngModel)]="categoryID" (ngModelChange)="categoryID"
                (selectionChange)="fetchMetaDataProperties(categoryID)">
                <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchCtrl" [placeholderLabel]="'Search...'"
                        [noEntriesFoundLabel]="'Not found'" name="search" [ngModelOptions]="{standalone: true}">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let category of categories|stringFilter:searchCtrl:'name'" [value]="category.id">
                    {{category.name}}
                </mat-option>
            </mat-select>
        </div>
        <form #initiateForm="ngForm">
            <div *ngIf="category">
                <div *ngFor="let property of category['meta_data_definition']['properties']; index as i;">
                    <div *ngIf="property.required==true">
                        <div *ngIf="property.data_type=='str' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}} *</span>
                            </div>
                            <input class="form-control" name="{{property.name}}"
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" type="text" [(ngModel)]="category.meta_data_definition.properties[i].value"
                                required>
                        </div>
                        <div *ngIf="property.data_type=='int' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}} *</span>
                            </div>
                            <input class="form-control" name="{{property.name}}"
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" type="number"
                                [(ngModel)]="category.meta_data_definition.properties[i].value" required>
                        </div>
                        <div *ngIf="property.data_type=='date' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <!-- <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}} *</span>
                            </div>
                            <input class="form-control" name="{{property.name}}"
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" type="date" [ngModel]="category.meta_data_definition.properties[i].value  | date:'yyyy-MM-dd'"
                                (change)="updateList(category.meta_data_definition.properties[i], property.name, $event)"
                                 (ngModel)="category.meta_data_definition.properties[i].value = $any($event).target.valueAsDate"
                                required> -->

                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}} *</span>
                            </div>
                            <div>
                                <input class="form-control" name="{{property.name}}" 
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" [matDatepicker]="datePicker"
                                [ngModel]="category.meta_data_definition.properties[i].value  | date:'yyyy-MM-dd'" (ngModel)="category.meta_data_definition.properties[i].value = $any($event).target.valueAsDate"
                                (dateChange)="updateList(category.meta_data_definition.properties, property, $event)" required>
                            </div>
                            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datePicker></mat-datepicker>
                            <mat-error *ngIf="property.isError">
                                Date is invalid.
                            </mat-error>
                        </div>
                        <div *ngIf="property.data_type=='bool' && !property.isHide" class="input-group-sm mt-2 input-group col-12">                         
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}} *</span>
                            </div>
                            <!-- <mat-slide-toggle ngDefaultControl class="ml-2" name="{{key.name}}" [(ngModel)]="values[key.name]">
                            </mat-slide-toggle> -->
                            <mat-select (selectionChange)="onSelectionChange($event)" ngDefaultControl class="form-control" name="{{property.name}}"
                                type="list"  [(ngModel)]="category.meta_data_definition.properties[i].value">                                
                                <mat-option value="true">True</mat-option>
                                <mat-option value="false">False</mat-option>
                            </mat-select>
                        </div>
                        <div *ngIf="property.data_type=='str array' && !property.isHide" class="input-group-sm mt-2 input-group col-12"
                            style="display: block;">
                            <form class="card p-2" [formGroup]="valuesForm">
                                <div formArrayName="{{property.name}}">
                                    <div class="row">
                                        <span class="form-group ml-3 form-label-105"
                                            style="font-size: small;">{{property.name}} *</span>
                                        <div class="col mb-2">
                                            <!-- <button mat-stroked-button > -->
                                            <mat-icon class="float-right" title="Add Value"
                                                (click)="addNewValue(property.name)">add</mat-icon>
                                            <!-- </button> -->
                                        </div>
                                    </div>
                                    <div *ngFor="let item of getValues(valuesForm, property.name); let i=index"
                                        [formGroupName]="i">
                                        <div class="row">
                                            <div class="col-11">
                                                <div class="row">
                                                    <div class="input-group-sm mt-2 input-group col-12 mb-2">
                                                        <input class="form-control" type="text"
                                                            [ngClass]="valuesForm.value[property.name][i].value!=''?'':'empty-input'"
                                                            formControlName="value" required>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1 p-0">
                                                <mat-icon (click)="deleteForm(i,property.name)" style="position: relative;
                                            top: 15%;" *ngIf="valuesArray(property.name).controls.length > 1">delete
                                                </mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div *ngIf="property.data_type=='object' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}} *</span>
                            </div>
                            <json-editor class="form-contol" #editor [options]="options"
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" [data]="category.meta_data_definition.properties[i].value"
                                (change)="changeLog($event)">
                            </json-editor>
                        </div>
                        <div *ngIf="property.data_type=='options' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}} *</span>
                            </div>
                            <mat-select (selectionChange)="onSelectionChange($event)" class="form-control" name="{{property.name}}"
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'"
                                type="list" [(ngModel)]="category.meta_data_definition.properties[i].value"
                                required>
                                <mat-option value="{{values}}" *ngFor="let values of property.values">{{values}}</mat-option>
                            </mat-select>
                        </div>
                    </div>



                        <!-- <mat-form-field *ngIf="property.data_type=='str' " class="col" appearance="standard">
                            <mat-label>{{property.name}}</mat-label>
                            <input matInput name="{{'name'+i}}"
                                [(ngModel)]="category.meta_data_definition.properties[i].value" required>
                        </mat-form-field>
                        <mat-form-field *ngIf="property.data_type=='int'" class="col" appearance="standard">
                            <mat-label>{{property.name}}</mat-label>
                            <input matInput name="{{'name'+i}}" type="number"
                                [(ngModel)]="category.meta_data_definition.properties[i].value" required>
                        </mat-form-field>
                        <div *ngIf="property.data_type=='bool'">
                            <label>{{property.name}}*</label>
                            <mat-slide-toggle name="{{'name'+i}}"
                                [(ngModel)]="category.meta_data_definition.properties[i].value">
                            </mat-slide-toggle>
                        </div>

                        <div *ngIf=" property.data_type=='object'">
                            <label class="ml-3">{{property.name}}</label>
                            <json-editor #editor [options]="options"
                                [data]="category.meta_data_definition.properties[i].value" (change)="changeLog($event)">
                            </json-editor>
                        </div>
                        <!-- <mat-slide-toggle class="pl-2 pr-2 pt-1" name="{{'name'+i}}"  [(ngModel)]="category.meta_data_definition.properties[i].value" required>
                        </mat-slide-toggle> -->


                        <!-- <mat-form-field *ngIf="property.data_type=='date'" class="col" appearance="standard">
                            <mat-label>{{property.name}}</mat-label>
                            <input matInput name="{{'name'+i}}" type="date"
                                [(ngModel)]="category.meta_data_definition.properties[i].value" required>
                        </mat-form-field>

                    </div> --> 





                    <div *ngIf="property.required==false">
                        <div *ngIf="property.data_type=='str' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}}</span>
                            </div>
                            <input class="form-control" name="{{property.name}}"
                                [ngClass]="property.name?'':'empty-input'" type="text" [(ngModel)]="category.meta_data_definition.properties[i].value"
                                >
                        </div>
                        <div *ngIf="property.data_type=='int' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}}</span>
                            </div>
                            <input class="form-control" name="{{property.name}}"
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" type="number"
                                [(ngModel)]="category.meta_data_definition.properties[i].value">
                        </div>
                        <div *ngIf="property.data_type=='date' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}}</span>
                            </div>
                            <div>
                                <input class="form-control" name="{{property.name}}" 
                                [matDatepicker]="datePicker"
                                [ngModel]="category.meta_data_definition.properties[i].value  | date:'yyyy-MM-dd'" (ngModel)="category.meta_data_definition.properties[i].value = $any($event).target.valueAsDate"
                                (dateChange)="updateList(category.meta_data_definition.properties, property, $event)">
                            </div>
                            <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                            <mat-datepicker #datePicker></mat-datepicker>
                            <mat-error *ngIf="property.isError">
                                Date is invalid.
                            </mat-error>
                        </div>
                        <div *ngIf="property.data_type=='bool' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}}</span>
                            </div>
                            <!-- <mat-slide-toggle ngDefaultControl class="ml-2" name="{{key.name}}" [(ngModel)]="values[key.name]">
                            </mat-slide-toggle> -->
                            <mat-select (selectionChange)="onSelectionChange($event)" ngDefaultControl class="form-control" name="{{property.name}}"
                                type="list"  [(ngModel)]="category.meta_data_definition.properties[i].value">                                
                                <mat-option value="true">True</mat-option>
                                <mat-option value="false">False</mat-option>
                            </mat-select>
                        </div>
                        <div *ngIf="property.data_type=='str array' && !property.isHide" class="input-group-sm mt-2 input-group col-12"
                            style="display: block;">
                            <form class="card p-2" [formGroup]="valuesForm">
                                <div formArrayName="{{property.name}}">
                                    <div class="row">
                                        <span class="form-group ml-3 form-label-105"
                                            style="font-size: small;">{{property.name}}</span>
                                        <div class="col mb-2">
                                            <!-- <button mat-stroked-button > -->
                                            <mat-icon class="float-right" title="Add Value"
                                                (click)="addNewValue(property.name)">add</mat-icon>
                                            <!-- </button> -->
                                        </div>
                                    </div>
                                    <div *ngFor="let item of getValues(valuesForm, property.name); let i=index"
                                        [formGroupName]="i">
                                        <div class="row">
                                            <div class="col-11">
                                                <div class="row">
                                                    <div class="input-group-sm mt-2 input-group col-12 mb-2">
                                                        <input class="form-control" type="text"
                                                            [ngClass]="property.name!=''?'':'empty-input'"
                                                            formControlName="value">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-1 p-0">
                                                <mat-icon (click)="deleteForm(i,property.name)" style="position: relative;
                                            top: 15%;" *ngIf="valuesArray(property.name).controls.length > 1">delete
                                                </mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div *ngIf="property.data_type=='object' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}}</span>
                            </div>
                            <json-editor class="form-contol" #editor [options]="options"
                                [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" [data]="category.meta_data_definition.properties[i].value"
                                (change)="changeLog($event)">
                            </json-editor>
                        </div>
                        <div *ngIf="property.data_type=='options' && !property.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{property.name}}</span>
                            </div>
                            <mat-select (selectionChange)="onSelectionChange($event)" class="form-control" name="{{property.name}}"
                                [ngClass]="property.name?'':'empty-input'"
                                type="list" [(ngModel)]="category.meta_data_definition.properties[i].value"
                                >
                                <mat-option value="{{values}}" *ngFor="let values of property.values">{{values}}</mat-option>
                            </mat-select>
                        </div>
                        <!-- <mat-form-field *ngIf="property.data_type=='str' " class="col" appearance="standard">
                            <mat-label>{{property.name}}</mat-label>
                            <input matInput name="{{'name'+i}}"
                                [(ngModel)]="category.meta_data_definition.properties[i].value">
                        </mat-form-field>
                        <mat-form-field *ngIf="property.data_type=='int'" class="col" appearance="standard">
                            <mat-label>{{property.name}}</mat-label>
                            <input matInput name="{{'name'+i}}" type="number"
                                [(ngModel)]="category.meta_data_definition.properties[i].value">
                        </mat-form-field>

                        <div *ngIf="property.data_type=='bool'" class="mt-2">
                            <mat-label class="ml-3">{{property.name}}</mat-label>
                            <mat-slide-toggle name="{{'name'+i}}" class="ml-2"
                                [(ngModel)]="category.meta_data_definition.properties[i].value">
                            </mat-slide-toggle>
                        </div>
                        <div *ngIf="property.data_type=='object'">
                            <label class="ml-3">{{property.name}}</label>
                            <json-editor #editor [options]="options"
                                [data]="category.meta_data_definition.properties[i].value" (change)="changeLog($event)">
                            </json-editor>
                        </div> -->
                        <!-- <mat-slide-toggle class="pl-2 pr-2 pt-1" name="{{'name'+i}}"  [(ngModel)]="category.meta_data_definition.properties[i].value" required>
                        </mat-slide-toggle> -->


                        <!-- <mat-form-field *ngIf="property.data_type=='date'" class="col" appearance="standard">
                            <mat-label>{{property.name}}</mat-label>
                            <input matInput name="{{'name'+i}}" type="date"
                                [(ngModel)]="category.meta_data_definition.properties[i].value">
                        </mat-form-field>

                    </div> -->
                    <!-- <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{property.name}}</span>
                    </div>
                    <input class="form-control" name="{{'name'+i}}"
                        [(ngModel)]="category.meta_data_definition.properties[i].value" required>
                </div> -->
            </div>
        </div>
            </div>
            <button mat-raised-button class="closeButton float-right mr-3 mt-1" (click)="back()">Back</button>
            <button mat-raised-button class="actionButton mr-3 mt-1" [disabled]="!initiateForm.valid"
                (click)="fetchServiceData()">Update</button>
                
                    </form>
    </div>

    <div class="card" *ngIf="uploadMessage">
        <div class="card-body">
            <div>Category has been updated.</div>
            <button style="margin: 3px; float: right;" mat-raised-button (click)="back()">Back</button>

        </div>
    </div>
    <div class="card" *ngIf="isError">
        <div class="card-body">
            <div style="text-align: center; color: red;">{{errorMessage}}</div>
        </div>
    </div>

</div>